import { useEffect, useState } from "react";
import ButtonIconH from "./ButtonIconH";
import MiniLineChart from "./MiniLineChart";
import moment from "moment";
import "../css/GlassesHistoryBox.css";

export default function AudiometryHistoryBox({ data, onOpen }) {
  const [airPointsL, setAirPointsL] = useState(null);
  const [airPointsR, setAirPointsR] = useState(null);
  const [bonePointsL, setBonePointsL] = useState(null);
  const [bonePointsR, setBonePointsR] = useState(null);
  const [thresholdPointsL, setThresholdPointsL] = useState(null);
  const [thresholdPointsR, setThresholdPointsR] = useState(null);

  useEffect(() => {
    setAirPointsR([
      { x: 125, y: data.aerea_d_125 },
      { x: 250, y: data.aerea_d_250 },
      { x: 500, y: data.aerea_d_500 },
      { x: 1000, y: data.aerea_d_1000 },
      { x: 1500, y: data.aerea_d_1500 },
      { x: 2000, y: data.aerea_d_2000 },
      { x: 3000, y: data.aerea_d_3000 },
      { x: 4000, y: data.aerea_d_4000 },
      { x: 6000, y: data.aerea_d_6000 },
      { x: 8000, y: data.aerea_d_8000 },
    ]);
    setAirPointsL([
      { x: 125, y: data.aerea_i_125 },
      { x: 250, y: data.aerea_i_250 },
      { x: 500, y: data.aerea_i_500 },
      { x: 1000, y: data.aerea_i_1000 },
      { x: 1500, y: data.aerea_i_1500 },
      { x: 2000, y: data.aerea_i_2000 },
      { x: 3000, y: data.aerea_i_3000 },
      { x: 4000, y: data.aerea_i_4000 },
      { x: 6000, y: data.aerea_i_6000 },
      { x: 8000, y: data.aerea_i_8000 },
    ]);
    setBonePointsR([
      { x: 125, y: data.osea_d_125 },
      { x: 250, y: data.osea_d_250 },
      { x: 500, y: data.osea_d_500 },
      { x: 1000, y: data.osea_d_1000 },
      { x: 1500, y: data.osea_d_1500 },
      { x: 2000, y: data.osea_d_2000 },
      { x: 3000, y: data.osea_d_3000 },
      { x: 4000, y: data.osea_d_4000 },
      { x: 6000, y: data.osea_d_6000 },
      { x: 8000, y: data.osea_d_8000 },
    ]);
    setBonePointsL([
      { x: 125, y: data.osea_i_125 },
      { x: 250, y: data.osea_i_250 },
      { x: 500, y: data.osea_i_500 },
      { x: 1000, y: data.osea_i_1000 },
      { x: 1500, y: data.osea_i_1500 },
      { x: 2000, y: data.osea_i_2000 },
      { x: 3000, y: data.osea_i_3000 },
      { x: 4000, y: data.osea_i_4000 },
      { x: 6000, y: data.osea_i_6000 },
      { x: 8000, y: data.osea_i_8000 },
    ]);
    setThresholdPointsR([
      { x: 125, y: data.umbral_d_125 },
      { x: 250, y: data.umbral_d_250 },
      { x: 500, y: data.umbral_d_500 },
      { x: 1000, y: data.umbral_d_1000 },
      { x: 1500, y: data.umbral_d_1500 },
      { x: 2000, y: data.umbral_d_2000 },
      { x: 3000, y: data.umbral_d_3000 },
      { x: 4000, y: data.umbral_d_4000 },
      { x: 6000, y: data.umbral_d_6000 },
      { x: 8000, y: data.umbral_d_8000 },
    ]);
    setThresholdPointsL([
      { x: 125, y: data.umbral_i_125 },
      { x: 250, y: data.umbral_i_250 },
      { x: 500, y: data.umbral_i_500 },
      { x: 1000, y: data.umbral_i_1000 },
      { x: 1500, y: data.umbral_i_1500 },
      { x: 2000, y: data.umbral_i_2000 },
      { x: 3000, y: data.umbral_i_3000 },
      { x: 4000, y: data.umbral_i_4000 },
      { x: 6000, y: data.umbral_i_6000 },
      { x: 8000, y: data.umbral_i_8000 },
    ]);
  }, [data]);

  return (
    <div className="history-box">
      <div className="history-box-header">
        <div
          className="history-box-header-fields"
          style={{ padding: "0px 20px", height: "30px" }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Fecha</span>
            <span>{moment(data.fecha).format("DD/MM/YYYY HH:mm:ss")}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Realizada por</span>
            <span>{data.audioprotesista}</span>
          </div>
        </div>
        <div style={{ padding: "5px" }}>
          <ButtonIconH
            text="Mostrar"
            small
            onClick={() => {
              onOpen(false);
            }}
          ></ButtonIconH>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div className="history-box-content" style={{ flex: 1 }}>
          <span className="history-box-tag history-box-title-bg">
            Oído derecho
          </span>
          <div
            className="history-box-content-header"
            style={{ gridTemplateColumns: "repeat(11, 1fr)" }}
          >
            <span className="history-box-tag">Hz</span>
            <span className="history-box-tag">125</span>
            <span className="history-box-tag">250</span>
            <span className="history-box-tag">500</span>
            <span className="history-box-tag">1000</span>
            <span className="history-box-tag">1500</span>
            <span className="history-box-tag">2000</span>
            <span className="history-box-tag">3000</span>
            <span className="history-box-tag">4000</span>
            <span className="history-box-tag">6000</span>
            <span className="history-box-tag">8000</span>
          </div>
          <div
            className="history-box-content-data"
            style={{
              gridTemplateColumns: "repeat(11, 1fr)",
              borderBottomLeftRadius: "0px",
              borderBottomRightRadius: "0px",
            }}
          >
            <span className="history-box-tag">Aérea</span>
            <span className="history-box-data">{data.aerea_d_125}</span>
            <span className="history-box-data">{data.aerea_d_250}</span>
            <span className="history-box-data">{data.aerea_d_500}</span>
            <span className="history-box-data">{data.aerea_d_1000}</span>
            <span className="history-box-data">{data.aerea_d_1500}</span>
            <span className="history-box-data">{data.aerea_d_2000}</span>
            <span className="history-box-data">{data.aerea_d_3000}</span>
            <span className="history-box-data">{data.aerea_d_4000}</span>
            <span className="history-box-data">{data.aerea_d_6000}</span>
            <span className="history-box-data">{data.aerea_d_8000}</span>
          </div>
          <div
            className="history-box-content-data"
            style={{
              gridTemplateColumns: "repeat(11, 1fr)",
              borderBottomLeftRadius: "0px",
              borderBottomRightRadius: "0px",
            }}
          >
            <span className="history-box-tag">Ósea</span>
            <span className="history-box-data">{data.osea_d_125}</span>
            <span className="history-box-data">{data.osea_d_250}</span>
            <span className="history-box-data">{data.osea_d_500}</span>
            <span className="history-box-data">{data.osea_d_1000}</span>
            <span className="history-box-data">{data.osea_d_1500}</span>
            <span className="history-box-data">{data.osea_d_2000}</span>
            <span className="history-box-data">{data.osea_d_3000}</span>
            <span className="history-box-data">{data.osea_d_4000}</span>
            <span className="history-box-data">{data.osea_d_6000}</span>
            <span className="history-box-data">{data.osea_d_8000}</span>
          </div>
          <div
            className="history-box-content-data"
            style={{
              gridTemplateColumns: "repeat(11, 1fr)",
              borderBottomLeftRadius: "0px",
              borderBottomRightRadius: "0px",
            }}
          >
            <span className="history-box-tag">Umbral</span>
            <span className="history-box-data">{data.umbral_d_125}</span>
            <span className="history-box-data">{data.umbral_d_250}</span>
            <span className="history-box-data">{data.umbral_d_500}</span>
            <span className="history-box-data">{data.umbral_d_1000}</span>
            <span className="history-box-data">{data.umbral_d_1500}</span>
            <span className="history-box-data">{data.umbral_d_2000}</span>
            <span className="history-box-data">{data.umbral_d_3000}</span>
            <span className="history-box-data">{data.umbral_d_4000}</span>
            <span className="history-box-data">{data.umbral_d_6000}</span>
            <span className="history-box-data">{data.umbral_d_8000}</span>
          </div>
          <span className="history-box-tag history-box-title-bg">
            Oído izquierdo
          </span>
          <div
            className="history-box-content-header"
            style={{ gridTemplateColumns: "repeat(11, 1fr)" }}
          >
            <span className="history-box-tag">Hz</span>
            <span className="history-box-tag">125</span>
            <span className="history-box-tag">250</span>
            <span className="history-box-tag">500</span>
            <span className="history-box-tag">1000</span>
            <span className="history-box-tag">1500</span>
            <span className="history-box-tag">2000</span>
            <span className="history-box-tag">3000</span>
            <span className="history-box-tag">4000</span>
            <span className="history-box-tag">6000</span>
            <span className="history-box-tag">8000</span>
          </div>
          <div
            className="history-box-content-data"
            style={{
              gridTemplateColumns: "repeat(11, 1fr)",
              borderBottomLeftRadius: "0px",
              borderBottomRightRadius: "0px",
            }}
          >
            <span className="history-box-tag">Aérea</span>
            <span className="history-box-data">{data.aerea_i_125}</span>
            <span className="history-box-data">{data.aerea_i_250}</span>
            <span className="history-box-data">{data.aerea_i_500}</span>
            <span className="history-box-data">{data.aerea_i_1000}</span>
            <span className="history-box-data">{data.aerea_i_1500}</span>
            <span className="history-box-data">{data.aerea_i_2000}</span>
            <span className="history-box-data">{data.aerea_i_3000}</span>
            <span className="history-box-data">{data.aerea_i_4000}</span>
            <span className="history-box-data">{data.aerea_i_6000}</span>
            <span className="history-box-data">{data.aerea_i_8000}</span>
          </div>
          <div
            className="history-box-content-data"
            style={{
              gridTemplateColumns: "repeat(11, 1fr)",
              borderBottomLeftRadius: "0px",
              borderBottomRightRadius: "0px",
            }}
          >
            <span className="history-box-tag">Ósea</span>
            <span className="history-box-data">{data.osea_i_125}</span>
            <span className="history-box-data">{data.osea_i_250}</span>
            <span className="history-box-data">{data.osea_i_500}</span>
            <span className="history-box-data">{data.osea_i_1000}</span>
            <span className="history-box-data">{data.osea_i_1500}</span>
            <span className="history-box-data">{data.osea_i_2000}</span>
            <span className="history-box-data">{data.osea_i_3000}</span>
            <span className="history-box-data">{data.osea_i_4000}</span>
            <span className="history-box-data">{data.osea_i_6000}</span>
            <span className="history-box-data">{data.osea_i_8000}</span>
          </div>
          <div
            className="history-box-content-data"
            style={{
              gridTemplateColumns: "repeat(11, 1fr)",
              borderBottomRightRadius: "0px",
            }}
          >
            <span className="history-box-tag">Umbral</span>
            <span className="history-box-data">{data.umbral_i_125}</span>
            <span className="history-box-data">{data.umbral_i_250}</span>
            <span className="history-box-data">{data.umbral_i_500}</span>
            <span className="history-box-data">{data.umbral_i_1000}</span>
            <span className="history-box-data">{data.umbral_i_1500}</span>
            <span className="history-box-data">{data.umbral_i_2000}</span>
            <span className="history-box-data">{data.umbral_i_3000}</span>
            <span className="history-box-data">{data.umbral_i_4000}</span>
            <span className="history-box-data">{data.umbral_i_6000}</span>
            <span className="history-box-data">{data.umbral_i_8000}</span>
          </div>
        </div>
        <div
          className="history-box-content"
          style={{ cursor: "pointer" }}
          onClick={() => {
            onOpen(true);
          }}
        >
          <MiniLineChart
            color={"#d81438"}
            bkgColor={"white"}
            airPoints={airPointsR}
            bonePoints={bonePointsR}
            thresholdPoints={thresholdPointsR}
          ></MiniLineChart>
          <MiniLineChart
            color={"#069dde"}
            bkgColor={"white"}
            airPoints={airPointsL}
            bonePoints={bonePointsL}
            thresholdPoints={thresholdPointsL}
          ></MiniLineChart>
        </div>
      </div>
    </div>
  );
}
